import React from 'react';
import PageBanner from '../components/PageBanner/PageBanner';
import crest from '../assets/images/baltsazar-crest.png';
import './Baltsazar.css';

export default function Baltsazar() {
  return (
    <>
      <PageBanner
        image="/gallery/full/event-007.jpg"
        eyebrow="Est. 1963"
        title="Baltsazar"
        subtitle="House TAU's own clubhouse, where socials and everyday House life actually happen."
        height="lg"
      />

      <section className="section">
        <div className="container baltsazar-intro">
          <div className="baltsazar-intro__text">
            <p className="section__eyebrow">The clubhouse</p>
            <h2>Our Home Within a Home</h2>
            <p className="prose">
              Baltsazar is House TAU's own clubhouse, founded in 1963, the same year as the
              House itself. It's where Ysters gather for socials and everyday House life, and
              it's the one place on the property that's unmistakably, entirely House TAU.
            </p>
            <p className="prose">
              From a quiet weekday hangout to a full social night, Baltsazar is the natural
              home for House gatherings of every size.
            </p>
          </div>
          <div className="baltsazar-intro__crest">
            <img src={crest} alt="Baltsazar's crest" />
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <p className="section__eyebrow">The emblem</p>
          <h2>Two Bulls, One Eiffel</h2>
          <p className="prose">
            Baltsazar's crest pairs the House's Eiffel with two bulls standing guard on
            either side, strength and steadfastness flanking the same tower that stands in
            the quad. "EST. 1963" ties it directly back to the founding of House TAU itself:
            the clubhouse has been part of the House for as long as the House has existed.
          </p>
        </div>
      </section>
    </>
  );
}
